import React from "react";

const DAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

/** Heatmap 7×24 do último mês. `matrix` é [7][24] de counts (weekday×hour).
 *  Cor: escala de branco→azul RAF (mais quente = mais volume).
 *  `onCellClick(day, hour)` opcional — usado para drill-down no histórico. */
export const CommHeatmap = ({ matrix, onCellClick }) => {
  if (!matrix || matrix.length !== 7) return null;
  const flat = matrix.flat();
  const max = Math.max(1, ...flat);
  const totalInbound = flat.reduce((a, b) => a + b, 0);
  const shade = (v) => {
    if (v === 0) return "rgba(226,232,240,0.6)"; // slate-200
    const t = v / max; // 0..1
    // interpola de #E0F2FE (sky-100) → #0B2B62 (RAF navy)
    const r = Math.round(224 + (11 - 224) * t);
    const g = Math.round(242 + (43 - 242) * t);
    const b = Math.round(254 + (98 - 254) * t);
    return `rgb(${r},${g},${b})`;
  };
  return (
    <div className="mt-4" data-testid="comm-heatmap">
      <div className="flex items-center justify-between mb-2">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Heatmap semanal · últimos 30 dias</div>
          <div className="text-[10px] text-slate-400">Respostas inbound (WA/SMS) por dia da semana × hora — descubra picos para escalar plantão</div>
        </div>
        <div className="text-[10px] text-slate-500">
          Total: <b className="text-slate-800">{totalInbound}</b> · pico <b className="text-slate-800">{max}</b>/célula
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="text-[9px] border-separate border-spacing-[2px]">
          <thead>
            <tr>
              <th className="w-8" />
              {Array.from({ length: 24 }, (_, h) => (
                <th key={h} className="w-5 text-slate-400 font-normal">{h % 3 === 0 ? h : ""}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {matrix.map((row, day) => (
              <tr key={day}>
                <td className="text-slate-500 font-semibold pr-1 text-right">{DAYS[day]}</td>
                {row.map((v, hour) => (
                  <td key={hour}
                      data-testid={`heatmap-cell-${day}-${hour}`}
                      title={`${DAYS[day]} ${String(hour).padStart(2,"0")}:00 — ${v} inbound${onCellClick ? " · clique para filtrar histórico" : ""}`}
                      onClick={onCellClick ? () => onCellClick(day, hour) : undefined}
                      style={{ backgroundColor: shade(v), width: 16, height: 16 }}
                      className={`rounded-sm ${onCellClick ? "cursor-pointer hover:ring-2 hover:ring-[#0B2B62]" : "cursor-help"}`}>
                    <span className={`block w-full h-full text-center ${v > max * 0.6 ? "text-white" : "text-slate-800"}`}>{v > 0 ? v : ""}</span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CommHeatmap;
